import { LocalStorageCache as Auth0LocalStorageCache } from '@auth0/auth0-spa-js/src/cache/cache-localstorage';
import { CACHE_KEY_PREFIX as AUTH0_CACHE_KEY_PREFIX } from '@auth0/auth0-spa-js/src/cache/shared';
export class LocalStorageCache extends Auth0LocalStorageCache {
    constructor(namespacePrefix) {
        super();
        this.namespacePrefix = namespacePrefix;
    }
    set(key, entry) {
        key = this.modifyKeyPrefix(key);
        super.set(key, entry);
    }
    get(key) {
        key = this.modifyKeyPrefix(key);
        return super.get(key);
    }
    remove(key) {
        key = this.modifyKeyPrefix(key);
        super.remove(key);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter(key => key.startsWith(this.namespacePrefix));
    }
    modifyKeyPrefix(key) {
        if (!key)
            return key;
        return key.replace(AUTH0_CACHE_KEY_PREFIX, this.namespacePrefix);
    }
}
//# sourceMappingURL=LocalStorageCache.js.map